
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Icon, Row, Col, Button, Divider, Dropdown, Menu, Calendar, message, Modal, Select, Badge, Spin } from 'antd';
import { getCookie } from './../../hook';
import './style.css';
import _ from 'underscore';
import moment from 'moment';

// Actions
import { 
    get_leave_type, 
    save_leave, 
    get_leave, 
    delete_leave, 
    get_leave_by_id, 
    update_leave, 
    upload_files,
    get_leave_company } from './actions/leave.action';

// Childs
import NewLeave from './childs/new.leave';
import EditLeave from './childs/edit.leave';


const confirm = Modal.confirm;
const Option = Select.Option;
class Leave extends Component {

    constructor( props ){
        super( props );

        this.state = {
            new_leave_modal: false,
            edit_leave_modal: false,
            data: [],
            edit_data: [],
            leave_type: [],
            leaves_list: [],
            company_list: [],
            attachment: '',
            company_filter: 'all',
            spinLoading: false
        }

        this.handleleave            = this.handleleave.bind( this );
        this.handleSubmit           = this.handleSubmit.bind( this );
        this.handleEditSubmit       = this.handleEditSubmit.bind( this );
        this.dateCellRender         = this.dateCellRender.bind( this );
        this.getListData            = this.getListData.bind( this );
        this.is_weekend             = this.is_weekend.bind( this );
        this.handleDateSelection    = this.handleDateSelection.bind( this );
        this.handleUpload_files     = this.handleUpload_files.bind( this );
        this.color_code             = this.color_code.bind( this );
        this.handleCompany          = this.handleCompany.bind( this );

    }

    handleCompany( value ){
        this.props.history.push( value );
        window.location.reload();
    }

    handleUpload_files( file ){
        this.props.upload_files( file );
    }

    handleleave(){
        this.setState({ new_leave_modal: true, edit_leave_modal: false });
        // this.props.history.push('/requests/new/leave');
    }

    handleSubmit( data ){
        this.setState({ spinLoading: true });
        this.props.save_leave( data );
    }

    handleEditSubmit( data ){
        this.setState({ spinLoading: true });
        this.props.update_leave( data );
    }

    handleDateSelection( e ){

        let self = this;

        if( e.key === '1' ){
            if( e.item.props.id !== 0 ){
                this.props.get_leave_by_id( e.item.props.id );
                // this.props.history.push('/requests/edit/leave/' + e.item.props.id );
            }
        } else if( e.key === '2' ){
            if( e.item.props.id !== 0 ){
                

                confirm({
                    title: 'Do you Want to delete this Leave?',
                    onOk() {
                        self.props.delete_leave( e.item.props.id );
                    },
                    onCancel() {
                        // Nothing
                    },
                });

            }
        }
    }

    color_code( approved, leave_type, unit ){
        
        if( approved === "1" && leave_type === 'Annual Leave' ){
            if( unit === "0.5" ){
                return "events annual_half_leave";
            } else {   
                return "events annual_leave";
            }
        } 
        
        if( approved === "1" && leave_type === 'Sick Leave' ){
            if( unit === "0.5" ){
                return "events sick_half_leave";
            } else {
                return "events sick_leave";
            }
        }

        if( approved === "1" && leave_type === 'Compassionate Leave' ){
            return "events compassionate_leave";
        }

        if( approved === "1" && leave_type === 'Wedding Leave' ){
            return "events wedding_leave";
        }

        if( approved === "1" && leave_type === 'Emergency Leave' ){
            return "events emergency_leave";
        }

        if( leave_type === 'Work From Home' ){
            return "events work_from_home";
        }
        return "events disabled";

    }

    dateCellRender( value ) {

        const user = getCookie('dv_hrms_user').split(',');
        const list_dates = this.getListData( value );

        return (
            <span>
                {
                    list_dates.map( ( item, i ) => {

                        if( item.user_id === user[1] ){
                            return <span className={ this.color_code( item.approved, item.leave_type, item.unit )  } id={ item.name } >
                                { item.name }
                            </span>
                        } else {
                            return <Dropdown key={ i } overlay={
                                <Menu onClick={ this.handleDateSelection }>
                                    <Menu.Item key="1" id={ item.id }>
                                        Edit
                                    </Menu.Item>
                                    <Menu.Item key="2" id={ item.id }>
                                        Delete
                                    </Menu.Item>
                                </Menu>
                            } trigger={[ 'click' ]}>
                            <span className={ this.color_code( item.approved, item.leave_type, item.unit ) } id={ item.name } >
                                { item.name }
                            </span></Dropdown>
                        }
                    })
                }
            </span>
        );

    }

    getListData( value ){

        let list_data= [];
        let current_date = moment( value ).format( 'YYYY-MM-DD' );

        // if( this.is_weekend( current_date ) === 'weekend' ){
        //     list_data.push( { id: 0, name: 'Weekend' } );
        // }

        _.map( this.state.leaves_list, ( item, i ) => { 
            if( item.date === current_date ){
                list_data.push( 
                    { 
                        id: item.leave_id, 
                        name: item.full_name, 
                        approved: item.approved, 
                        user_id: item.user_id, 
                        leave_type: item.leave_type,
                        unit: item.unit,
                    }
                );
                return false;
            }
        });

        return list_data;
        
    }

    is_weekend( date1 ){

        let dt = new Date(date1),weekend=[],off = '';

        if( this.state.weekends ){
            weekend = this.state.weekends.split(',');
        }
        
        _.map( weekend, ( item, i )=> {
            if( dt.getDay() == parseInt( item ) ){
                off = "weekend";
            } 
        })

        return off;
         
    }
    componentWillMount(){
        
        const user = getCookie('dv_hrms_user').split(',');
        let company_filter = this.props.match.params.cp;

        this.props.get_leave_type();
        this.props.get_leave( user[6], company_filter );
        this.props.get_leave_company();

        this.setState({
            company_filter: company_filter
        })


    }

    componentWillReceiveProps( nextProps ){

        message.config({
            duration: 2,
        });

        if( nextProps.leave.length === 0 ){
            console.log( 'Slow Data Fetching ...' )
            return false;
        }

        if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Listed company" ){
            this.setState({
                company_list: nextProps.leave.OUTPUT.DATA 
            })
        }

        if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "File Uploaded" ) {
            this.setState({
                attachment: nextProps.leave.OUTPUT.DATA
            })
            return false;
        }

        this.setState({ new_leave_modal: false, edit_leave_modal: false });

        if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Listed Leave Type" ) {
            
            this.setState({
                leave_type: nextProps.leave.OUTPUT.DATA 
            })

        } else if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Saved leave" ) {
            
            message.success( 'Successfully Saved leave' );

            setTimeout(() => {
                window.location.reload();
            },600);

            const user = getCookie('dv_hrms_user').split(',');
            let company_filter = this.props.match.params.cp;

            this.props.get_leave_type();
            this.props.get_leave( user[6], company_filter );
            
        } else if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Listed Leaves" ) {
            
            this.setState({
                leaves_list: nextProps.leave.OUTPUT.DATA,
                weekends: nextProps.leave.OUTPUT.DATA[0].weekends
            })

            
        } else if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Deleted Leave" ){

            message.success( 'Successfully Deleted leave' );

            const user = getCookie('dv_hrms_user').split(',');
            let company_filter = this.props.match.params.cp;

            this.props.get_leave_type();
            this.props.get_leave( user[6], company_filter );

        } else if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Listed Leaves Edit" ){

            this.setState({
                edit_data: nextProps.leave.OUTPUT.DATA,
                new_leave_modal: false,
                edit_leave_modal: true,
            })

        } else if( nextProps.leave.STATUS.CODE === "200" && 
            nextProps.leave.STATUS.MESSAGE === "Successfully Updated leave" ){

            message.success( 'Successfully Updated leave' );

            setTimeout(() => {
                window.location.reload();
            },600);

            const user = getCookie('dv_hrms_user').split(',');
            let company_filter = this.props.match.params.cp;

            this.props.get_leave_type();
            this.props.get_leave( user[6], company_filter );
            

        } else if( nextProps.leave.STATUS.CODE === "400" ){
            if( nextProps.leave.STATUS.MESSAGE !== 'Error: 0 results' ){
                message.error( nextProps.leave.STATUS.MESSAGE );
            }
        }

    }

    render() {

        const company_list_view = this.state.company_list.map( ( item, k ) => <Option value={ item.company_id }>{ item.company_name }</Option> )

        return (
            <div className="leave_wrapper">
                <Spin spinning={ this.state.spinLoading }>
                <Row gutter={16}>
                    <Col span={6}>
                        
                        <h2>
                            <Icon type="calendar" />
                            &nbsp; Leave Management
                        </h2>

                    
                    </Col>
                    <Col span={18}>

                        <Button
                            onClick={ this.handleleave }
                            className="fl_right" type="primary" icon="plus">Add leave</Button>
                        <div style={{clear: 'both' }} className="leave_traker_info fl_right">    
                            <br />
                            <Badge color="#149429" text="Annual Leave" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#0000CD" text="Sick Leave" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#FFD700" text="Compassionate Leave" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#800080" text="Wedding Leave" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#DC143C" text="Emergency Leave" />&nbsp;&nbsp;&nbsp;
                            <Badge color="#a14508" text="Work From Home" />
                        </div>
                    </Col>
                </Row>

                <Divider />

                <Row gutter={16}>
                    <Col span={24}>
                        
                        <div style={{ position: 'absolute', top: '10px' }}>
                            <Select
                                defaultValue={ this.state.company_filter }
                                onChange={ this.handleCompany }
                                placeholder="Select Company"
                                style={{ width: '250px' }}>
                                <Option value="all">All</Option>
                                { company_list_view }
                            </Select>

                        </div>

                        <Calendar dateCellRender={ this.dateCellRender } />
                        
                    </Col>
                </Row>

                <NewLeave attachment={ this.state.attachment } leave_type={ this.state.leave_type } onUpload={ this.handleUpload_files } onSubmit={ this.handleSubmit } onModel={ this.state.new_leave_modal } />
                <EditLeave attachment={ this.state.attachment } data={ this.state.edit_data } leave_type={ this.state.leave_type } onUpload={ this.handleUpload_files } onSubmit={ this.handleEditSubmit } onModel={ this.state.edit_leave_modal } />
                
                </Spin>

            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        leave: state.leave
    }
}

export default connect( mapStatetoProps, { 
    get_leave_type, 
    save_leave, 
    get_leave, 
    delete_leave, 
    get_leave_by_id, 
    update_leave, 
    upload_files,
    get_leave_company })( Leave );


// WEBPACK FOOTER //
// ./src/pages/leave/index.js